import classNames from "classnames";
import { useId } from "react";
import type { InitialsSelection } from "schemas";
import { flexStyles, marginStyles } from "../styles";
import { SmallCircle } from "./SmallCircle";
import { SmallContactInitials } from "./SmallContactInitials";

interface Props {
  initials: InitialsSelection;
}
export function SmallInitialsGroup({ initials: { selection, total } }: Props) {
  const extra = total - selection.length;
  const extraLabel = extra > 1000 ? `+${Math.round(extra / 1000)}K` : `+${extra}`;
  const id = useId();

  return (
    <div className={flexStyles.horiz}>
      {selection.map((initials, index) => (
        <SmallContactInitials
          // biome-ignore lint:
          key={`smi-${id}-${index}`}
          className={marginStyles.msNegative075}
          contact={{ initials }}
        />
      ))}
      {extra > 0 && <SmallCircle className={classNames(marginStyles.msNegative075)} text={extraLabel} />}
    </div>
  );
}
